<template>
    <v-container fluid class="fill-height" style="background-color: var(--v-theme-background);">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="elevation-12 pa-3 rounded-lg">
            <v-toolbar color="appbar" flat>
              <v-toolbar-title class="text-h5 font-weight-bold primary--text d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-login-variant</v-icon>
                Login to Rentals App
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pa-sm-6 pa-4">
              <v-alert v-if="authStore.error" type="error" density="compact" variant="tonal" class="mb-4">
                {{ authStore.error }}
              </v-alert>
              <v-form ref="loginForm" v-model="isFormValid" @submit.prevent="handleLogin">
                <v-text-field
                  v-model="email"
                  label="Email Address"
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined"
                  type="email"
                  :rules="[rules.required, rules.email]"
                  required
                  class="mb-4"
                  color="primary"
                  @input="authStore.clearError()"
                ></v-text-field>
  
                <v-text-field
                  v-model="password"
                  label="Password"
                  prepend-inner-icon="mdi-lock-outline"
                  variant="outlined"
                  :type="showPassword ? 'text' : 'password'"
                  :append-inner-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                  @click:append-inner="showPassword = !showPassword"
                  :rules="[rules.required]"
                  required
                  class="mb-2"
                  color="primary"
                  @input="authStore.clearError()"
                ></v-text-field>
  
                <CaptchaField v-model:captchaAnswer="captchaAnswer" />
                
                <div class="d-flex justify-end mb-6">
                  <!-- <a href="#" class="text-primary text-caption text-decoration-none">
                    Forgot Password?
                  </a> -->
                  <v-btn text variant="text" @click="$router.push('/forgot')">Forgot password?</v-btn>
                </div>
  
                <v-btn
                  :loading="authStore.loading"
                  :disabled="!isFormValid || authStore.loading"
                  block
                  color="primary"
                  size="large"
                  type="submit"
                  class="py-3"
                >
                  Login
                </v-btn>
              </v-form>
  
              <v-divider class="my-6">
                <span class="text-caption text-disabled">OR</span>
              </v-divider>
  
              <v-btn
                block
                variant="outlined"
                color="red-darken-1"
                size="large"
                @click="loginWithGoogle"
                class="py-3"
                :disabled="authStore.loading"
              >
                <v-icon left class="mr-2">mdi-google</v-icon>
                Login with Google
              </v-btn>
            </v-card-text>
             <v-card-actions class="justify-center pa-4">
               <span class="text-caption text-disabled">Don't have an account?</span>
               <router-link :to="{ name: 'Register' }" class="text-primary text-caption font-weight-medium text-decoration-none ml-1">
                  Sign Up
                </router-link>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useAuthStore } from '@/stores/auth';
  import CaptchaField from './CaptchaField.vue';
  // import axios from 'axios';
  import apiClient from '@/services/api';
  // import { useRouter } from 'vue-router'; // Router is used by authStore for navigation

  const authStore = useAuthStore();
  // const router = useRouter();
  
  const loginForm = ref(null);
  const isFormValid = ref(false);
  const email = ref(''); // Prefill for testing: ref('admin@example.com');
  const password = ref(''); // Prefill for testing: ref('password');
  const showPassword = ref(false);
  
  const rules = {
    required: value => !!value || 'This field is required.',
    email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid.',
  };
  
  const handleLogin = async () => {
    if (!loginForm.value) return;
    const { valid } = await loginForm.value.validate();
  
    if (valid) {

      const isCaptchaValid = await validateCaptcha()
      if (!isCaptchaValid) {
        alert('CAPTCHA failed')
        return
      }

      await authStore.login({ email: email.value, password: password.value, captcha_answer: captchaAnswer.value });
      // Navigation is handled by the authStore on success
    }
  };

  const captchaAnswer = ref('')

  async function validateCaptcha() {
    const res = await apiClient.post('/captcha/validate', {
      answer: captchaAnswer.value
    })
    return res.data.valid
  }
  
  const loginWithGoogle = () => {
    authStore.loginWithGoogle();
  };

  </script>

  <style scoped>
  .fill-height {
    min-height: calc(100vh - 64px); /* Adjusted for no footer on login page */
  }
  .primary--text { color: var(--v-theme-primary) !important; }
  .text-primary { color: var(--v-theme-primary) !important; }
  .v-card { border-top: 4px solid var(--v-theme-primary); }
  .v-toolbar-title { line-height: 1.5rem; }
  </style>
  